
import React from 'react';
import Plausible from 'plausible-tracker';

const usePageTracking = () => {
    React.useEffect(() => {
        if (process.env.REACT_APP_LOCAL !== 'true') {
            console.log('Plausible - initialized')

            const plausible = Plausible({
                domain: 'parcel-online.hfbiz.cz',
                hashMode: true
            });
            plausible.enableAutoPageviews();
        } else {
            console.log('Plausible - not initialized (local development)')
        }
    }, []);
};

export default usePageTracking;
